import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { CONFIG } from '../config';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';

function _window(): any {
  return window;
}

@Injectable()
export class CommonService {
  get nativeWindow(): any {
    return _window();
  }
  get url(): string {
    return CONFIG.url_social;
  }

  constructor() { }

  openWindows(url: string){
    this.nativeWindow.window.open(url, 'twitter', 'channelmode=1');
  }
  closeWindows(){
    this.nativeWindow.window.close();
  }
};



// WEBPACK FOOTER //
// ./src/app/social/common.service.ts